function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedoIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 60,
  height: 40,
  viewBox: "0 0 122.04 122.88",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M117.31 9.3v39.28H73.4l3.27-3.28 11.45-11.45c-.75-.73-1.54-1.44-2.36-2.11-1.08-.88-2.22-1.72-3.38-2.48-6.02-3.93-13.21-6.21-20.94-6.21h-.01v-.01c-10.59 0-20.18 4.3-27.12 11.24S23.07 50.81 23.07 61.39h.01v.05h-.01c0 10.59 4.3 20.19 11.24 27.12C41.25 95.5 50.84 99.8 61.42 99.8v-.01h.08v.01c3.7 0 7.39-.54 10.93-1.59 1.95-.58 3.87-1.33 5.71-2.22 9.39-4.54 16.65-12.8 19.87-22.87l.43-1.33h23.61l-.47 2.3-.01.06v.01c-.81 3.84-2.01 7.62-3.54 11.24v.01c-1.5 3.55-3.37 6.98-5.52 10.19-11.02 16.43-29.78 27.26-51.05 27.26h-.02v-.01c-16.96 0-32.33-6.88-43.43-17.99v-.01C6.89 93.77.02 78.42.01 61.47H0v-.05h.01c0-16.96 6.88-32.32 18-43.43C29.11 6.89 44.46.02 61.41.01V0h.06v.01c8.71 0 17.01 1.83 24.51 5.1 1.21.53 2.43 1.1 3.6 1.71a61.4 61.4 0 0 1 14.83 10.74l9.61-9.61 3.27-3.27V9.3z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }
}));
export { SvgRedoIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/redo-icon.svg";